import axios from 'axios';
import { getHttpException } from '../exceptions/httpStatusExceptions';
import { NoNetworkException } from '../exceptions/networkExceptions';
import requestLogout from '../redux/actions/requestLogout';
import store from '../redux/store';
import EnvConfig from './config/envConfig';

export const USER_ID_PLACEHOLDER = 'USER_ID_PLACEHOLDER';

export const onFulfilledRequest = (originalConfig) => {
  let config = { ...originalConfig };
  const { userToken, userId } = store.getState().persist.session;

  if (userToken) {
    const authHeader = { Authorization: `Bearer ${userToken}` };
    config = {
      ...config,
      headers: {
        ...config.headers,
        ...authHeader,
      },
    };
  }

  if (config.url && typeof config.url === 'string') {
    const userIdMatches = new RegExp(USER_ID_PLACEHOLDER, 'g');
    const editedUrl = config.url.replace(userIdMatches, userId);
    config = {
      ...config,
      url: editedUrl,
    };
  }

  return config;
};

export const onRejectedResponse = (error) => {
  if (error.response) {
    const { status } = error.response;
    if (status === 401 && !error.config.isLoginRequest) {
      store.dispatch(requestLogout());
    }
    const httpException = getHttpException(status);
    httpException.setResponseData(error.response.data);
    throw httpException;
  } else if (error.request) {
    if (
      error.code === 'ECONNABORTED' &&
      error.message &&
      error.message.includes('timeout')
    ) {
      throw new NoNetworkException();
    }
  }
  throw error;
};

export const onResolvedResponse = (response) => response.data;

const mothershipClient = axios.create({
  baseURL: EnvConfig.getMothershipBaseUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});
mothershipClient.interceptors.request.use(onFulfilledRequest);
mothershipClient.interceptors.response.use(
  onResolvedResponse,
  onRejectedResponse,
);

export default mothershipClient;
